import {useSharedValueEffects} from '@epic-core/hooks';
import {PurchaseEffects} from './shared/purchase.effect';
import {WishlistEffects} from './shared/wishlist.effect';

export const AppEffects = () => {
    useSharedValueEffects([PurchaseEffects, WishlistEffects]);

    return null;
};
